
import ParameterComboBox from './ParameterComboBox';
import ParameterDatePicker from './ParameterDatePicker';
import ParameterTextBox from './ParameterTextBox';

export default function getParameterDefinitions() {
    let paramDefinitions = {
        'ComboBox': {
            component: ParameterComboBox,
            props: ['id', 'options', 'title', 'value', 'values', 'onChangeValue']
        },
        'DatePicker': {
            component: ParameterDatePicker,
            props: ['id', 'options', 'title', 'value', 'onChangeValue']
        },
        'TextBox': {
            component: ParameterTextBox,
            props: ['id', 'options', 'title', 'value', 'onChangeValue', 'onConfirm' ]
        },
    };

    return paramDefinitions;
}